import React from "react"

import TopicLayout from "../shared/TopicLayout"
import {Arrow, Box, Diagram} from "../shared/Diagram"

export default function StrongVsEventualConsistency() {
    return (
        <TopicLayout
            title="Strong vs. eventual consistency"
            intro="Whether a read is guaranteed to reflect the most recent write, or may briefly return an older value while replicas catch up. This is a spectrum of choices, not a single on/off switch."
            diagram={
                <Diagram viewBox="0 0 560 200">
                    <text x={280} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Strong — write waits for the replica</text>
                    <Box x={20} y={24} width={70} height={34} label="Client"/>
                    <Box x={170} y={24} width={80} height={34} label="Primary" accent/>
                    <Box x={330} y={24} width={80} height={34} label="Replica"/>
                    <Arrow x1={90} y1={38} x2={170} y2={38} label="write"/>
                    <Arrow x1={250} y1={38} x2={330} y2={38} label="sync + ack"/>
                    <Arrow x1={170} y1={52} x2={90} y2={52} label="ack"/>
                    <text x={280} y={80} textAnchor="middle" fontSize={11} opacity={0.7}>Read after write always sees the new value</text>

                    <line x1={10} y1={100} x2={550} y2={100} stroke="var(--header-background)" opacity={0.25}/>

                    <text x={280} y={114} textAnchor="middle" fontSize={12} opacity={0.8}>Eventual — write returns immediately</text>
                    <Box x={20} y={124} width={70} height={34} label="Client"/>
                    <Box x={170} y={124} width={80} height={34} label="Primary" accent/>
                    <Box x={330} y={124} width={80} height={34} label="Replica"/>
                    <Arrow x1={90} y1={138} x2={170} y2={138} label="write"/>
                    <Arrow x1={170} y1={152} x2={90} y2={152} label="ack"/>
                    <Arrow x1={250} y1={138} x2={330} y2={138} label="replicate" dashed muted/>
                    <text x={280} y={180} textAnchor="middle" fontSize={11} opacity={0.7}>A read from the replica may briefly be stale</text>
                </Diagram>
            }
            useWhen={[
                'Strong consistency: a stale read could cause harm, such as double-spending funds or overselling inventory.',
                'Eventual consistency: a short propagation delay is acceptable, such as for search indexes, recommendations, notification counts or analytics.'
            ]}
            tradeOff="Stronger coordination usually increases latency and can reduce availability during failures. CAP applies specifically when a network partition occurs: a distributed system cannot simultaneously guarantee linearizable consistency and that every request receives a non-error response. Outside partitions, systems still make separate latency, durability and consistency choices."
            ruleOfThumb="Keep the correctness-critical state strongly consistent, then allow derived views such as search, notifications and reporting to converge asynchronously."
        />
    )
}
